export default {
  title: 'Escolher ícone do site',
  createSuccess: 'O ícone foi definido com sucesso.',
  createError: 'Erro ao definir o ícone do site.'
}
